import type { ChatMessage, PeerRecord, UserProfile } from '@skychat/shared-core';

export const PREVIEW_ME: UserProfile = {
  id: 'sky', nickname: 'Sky', presence: 'available', typing_animation: 'poke-1',
  custom_status_icon: '☕', custom_status_text: 'Polishing mobile UI', show_weather: true,
  weather: {
    cityName: 'Rome', temperature: 22, showWeather: true, icon: 'cloud-sun.svg',
    conditionDescription: 'Partly cloudy', updatedAt: Date.now(),
    forecast: [
      { date: Date.now() + 86400000, tempMin: 17, tempMax: 24, icon: 'sunny.svg' },
      { date: Date.now() + 172800000, tempMin: 18, tempMax: 25, icon: 'cloud-sun.svg' },
      { date: Date.now() + 259200000, tempMin: 16, tempMax: 22, icon: 'cloud-rain.svg' },
      { date: Date.now() + 345600000, tempMin: 15, tempMax: 21, icon: 'cloud-sun.svg' }
    ]
  }
};

export const PREVIEW_PEERS: PeerRecord[] = [
  { id: 'luna', nickname: 'Luna', status: 'accepted', presence: 'available', typing_animation: 'cat-rainbown', type: 'friend', weather: { cityName: 'Milan', temperature: 19 } },
  { id: 'team-mobile', name: 'Mobile Rewrite', ownerId: 'sky', type: 'group', status: 'accepted', createdAt: Date.now() - 86400000 },
  { id: 'nova', nickname: 'Nova', status: 'accepted', presence: 'custom', custom_status_icon: '🎧', custom_status_text: 'Focus mode', typing_animation: 'poke-3', type: 'friend' }
];

export const PREVIEW_MESSAGES: Record<string, ChatMessage[]> = {
  luna: [
    { id: 'p1', fromId: 'luna', toId: 'sky', ts: Date.now() - 360000, type: 'text', plain: 'The new mobile shell feels much cleaner already.' },
    { id: 'p2', fromId: 'sky', toId: 'luna', ts: Date.now() - 240000, type: 'text', plain: 'Ionic transitions, action sheets, secure storage, the whole thing.', status: 'read' },
    { id: 'p3', fromId: 'luna', toId: 'sky', ts: Date.now() - 190000, type: 'text', plain: 'Preview link: https://chat.webhelloworld.it', status: 'delivered' },
    { id: 'p4', fromId: 'luna', toId: 'sky', ts: Date.now() - 172000, type: 'text', plain: 'YouTube: https://www.youtube.com/watch?v=aqz-KE-bpKQ', status: 'delivered' },
    { id: 'p5', fromId: 'luna', toId: 'sky', ts: Date.now() - 168000, type: 'text', plain: 'Bilibili: https://www.bilibili.com/video/BV1xx411c7mD', status: 'delivered' },
    { id: 'p6', fromId: 'luna', toId: 'sky', ts: Date.now() - 160000, type: 'image', plain: 'background_light.webp', file: { name: 'background_light.webp', type: 'image/webp', url: '/background/background_light.webp' }, status: 'delivered' },
    { id: 'p7', fromId: 'sky', toId: 'luna', ts: Date.now() - 130000, type: 'gif', plain: '[GIF]', payload: { url: '/sprite/cat-rainbown.gif' }, status: 'read' }
  ],
  'team-mobile': [
    { id: 'g1', fromId: 'nova', toId: 'team-mobile', ts: Date.now() - 420000, type: 'text', plain: 'Games, weather, pet and whiteboard all have their own mobile entry points now.' },
    { id: 'g2', fromId: 'sky', toId: 'team-mobile', ts: Date.now() - 180000, type: 'text', plain: 'Next pass can wire each engine deeper behind these screens.', status: 'delivered' }
  ],
  nova: [{ id: 'n1', fromId: 'nova', toId: 'sky', ts: Date.now() - 720000, type: 'text', plain: 'Ping me when the native build is ready.' }]
};
